import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getRouterLinkUrlById } from '@lsq-frontend/common-ui';
import { LifecycleAware } from '@lsq-frontend/common-ui';
import {
    ADMIN_DOCUMENTS,
    ADMIN_OVERVIEW,
    atlas
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
    ProspectService,
    SchemaService,
    Prospect,
    StageSchema,
    StageData,
    DocumentService,
    FieldSchema,
    FieldOption
} from '@lsq-frontend/remote-services/ar-app';
import { DrApplicationService } from '@lsqlabs/dr-application-shared';
import { forLifeOf, getDynamicRouteLink, ModalService } from '@lsq-frontend/common-ui';
import { AlertService } from '@lsq-frontend/angular-shared/features/alert-service';

@LifecycleAware()
@Component({
    selector: 'admin-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AdminDocumentsComponent {
    public prospectDataId: string;
    public readonly noDataTitle = 'No documents have been requested.';
    public dynamicRouterLink;
    public companyKey: string;

    constructor(
        private fb: FormBuilder,
        private _activatedRoute: ActivatedRoute,
        private _prospectService: ProspectService,
        private _schemaService: SchemaService,
        private _arService: DrApplicationService,
        private _documentService: DocumentService,
        private _alertService: AlertService,
        private _router: Router,
        private _modalService: ModalService
    ) {
        this._activatedRoute.params.pipe(forLifeOf(this)).subscribe(async (params) => {
            this.companyKey = params?.companyKey;
            this.getDyamnicRouterLink(this.companyKey);
        });
    }

    public navigateBackToClientManagement(): void {
        this._router.navigateByUrl(getRouterLinkUrlById(atlas, ADMIN_OVERVIEW));
    }

    public getBusinessName(): string {
        return this._arService.getProspect()?.businessName;
    }

    public formGroup: FormGroup = this.fb.group({});

    public getDyamnicRouterLink(companyKey: string) {
        this.dynamicRouterLink = getDynamicRouteLink(getRouterLinkUrlById(atlas, ADMIN_DOCUMENTS), {
            companyKey
        });
    }
}
